module.exports = __webpack_public_path__ + "fonts/unicredit-regular.e1e23afb.eot";